import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import PropTypes from "prop-types";
import { Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Paginator from "../../../directorio/Paginator";
import CopiarMetaModal from "./planComercialCampanaComponents/CopiarMetaModal";
import AgregaMetaSedeModal from "./planComercialCampanaComponents/AgregaMetaSedeModal";
import { useManagePostRequest } from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import { cuadroRequerimientosEliminarMetaComercialCampanaAPI, cuadroRequerimientosGetAllCampanasDropDownAPI, cuadroRequerimientosGetDataToEditMetaComercialCampanaAPI, cuadroRequerimientosGetListaMetaComercialCampanaAPI, cuadroRequerimientosGetSedesNotInMetaComercialCampanaAPI, getAllSedesAPI } from "../../../../consumers/backendApisUrls";
import { useManageGetRequest } from "../../../../hooks/useManageGetRequest/useManageGetRequest";
import FormSelect from "../../../../components/atoms/Select";
import {PrimaryActionButtonForPage} from "../../styledComponents/styledComponents";
import { v4 as uuidv4 } from 'uuid';
import {onKeyPressEnter} from "../../../../helper/utils";

const Styles = styled.div`
  height: 100%;

  .header-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
  }

  .btn-action {
    display: flex;
    align-items: center;
    border: none;
    border-radius: 4px;
    padding: 6px 15px;
    cursor: pointer;
    transition: background-color 0.2s;
    font-family: GothamLight;
    font-size: 14px;
    background-color: #d8d8d8;
    color: #fff;

    &:focus {
        outline: none;
    }
    
    &:hover {
        background-color: #1890ff;
    }
  }

  .table-container {
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  }

  .custom-table {
    width: 100%;
    margin-bottom: 0;
    
    thead th {
      background-color: #f1f1f1;
      color: #555;
      font-weight: 600;
      text-align: center;
      vertical-align: middle;
      border-bottom: 1px solid #dee2e6;
    }

    tbody td {
      vertical-align: middle !important;
      color: #666;
      border-bottom: 1px solid #dee2e6;
    }

    tbody tr:last-child td {
        border-bottom: none;
    }

    tbody tr:hover {
        background-color: #f8f9fa;
    }

    .col-sede {
      text-align: left;
      padding-left: 20px;
    }
    .col-total {
        width: 15%;
        text-align: left;
    }
    .col-options {
      text-align: center;
      width: 15%;
    }
  }

  .action-icon {
    cursor: pointer;
    margin: 0 8px;
    
    &:hover {
      color: #1890ff;
    }
  }

  @media (max-width: 992px) {
    .table {
      display: block;
    }
    .egssth .description {
      border: 0 !important;
    }
  }
`;

const PlanComercialCampana = ({ campana }) => {
    const [executeManageGetRequest] = useManageGetRequest();
    const [executeManagePostRequest] = useManagePostRequest();

    const [showCopiarMetaModal, setShowCopiarMetaModal] = useState(false);
    const [resCampanasDropDown, setResCampanasDropDown] = useState([]);

    const [titleSedeModal, setTitleSedeModal] = useState('');
    const [modeSedeModal, setModeSedeModal] = useState(false);
    const [dataSedeModal, setDataSedeModal] = useState({});

    const [showSedeModal, setShowSedeModal] = useState(false);
    const [metaSedeModalOptions, setMetaSedeModalOptions] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);

    const [resMetaComercialCampana, setResMetaComercialCampana] = useState({});
    const [sedesSeleccionados, setSedesSeleccionados] = useState([]);
    const [sedesFiltradosOptions, setSedesFiltradosOptions] = useState([]);
    const [allSedesOptions, setAllSedesOptions] = useState([]);

    const totalItems = resMetaComercialCampana?.TotalItems ?? 0;
    const indexOfLastItem = resMetaComercialCampana?.LastItemPage ?? 1;
    const indexOfFirstItem = resMetaComercialCampana?.FirsItemPage ?? 1;
    const totalPages = resMetaComercialCampana?.TotalPages ?? 1;

    const [searchCriteria, setSearchCriteria] = useState("");


    const prevPage = () => {
        const nextPage = Math.max(currentPage - 1, 1);
        setCurrentPage(nextPage);
    };

    const nextPage = () => {
        const nextPage = Math.min(currentPage + 1, totalPages);
        setCurrentPage(nextPage);
    };

    const handleOpenCopiarMetaModal = async () => {
        await executeManageGetRequest(
            cuadroRequerimientosGetAllCampanasDropDownAPI(),
            async (res) => {
                const campanasDropDown = (await res.data ?? []).map(c => ({ value: c.Value, label: c.Text })).filter(c => c.value !== campana.IdCampana);
                setResCampanasDropDown(campanasDropDown);
                setShowCopiarMetaModal(!showCopiarMetaModal);
            },
            false
        );
    };

    const handleCloseCopiarMetaModal = () => {
        setShowCopiarMetaModal(!showCopiarMetaModal);
    };

    const handleOpenSedeModal = async () => {
        await executeManageGetRequest(
            cuadroRequerimientosGetSedesNotInMetaComercialCampanaAPI(campana.IdCampana),
            async (res) => {
                const dataFormated = (await res?.data ?? []).map((item) => ({
                    value: item.Value,
                    label: item.Text
                }));
                setMetaSedeModalOptions(dataFormated);
                setTitleSedeModal("Nueva Meta Comercial Por Sede");
                setModeSedeModal(false);
                setShowSedeModal(!showSedeModal);
            },
            false
        );
    };

    const handleCloseSedeModal = () => {
        setShowSedeModal(!showSedeModal);
    };

    const updateOptionsDeFiltros = async (objectResponse, listSedes = []) => {
        const sedes = objectResponse["IdsSedes"] ?? [];
        const sedesOptions = (listSedes.length > 0 ? listSedes : allSedesOptions).filter(s => sedes.includes(s.Value));
        setSedesFiltradosOptions(sedesOptions);
    };

    const refetchMetaComercialCampana = async (IdsSedes = [], Page = 1, listSedes = []) => {
        const payload = {
            IdsSedes,
            IdCampana: campana.IdCampana,
            Criteria: searchCriteria,
            Page
        };
        await executeManagePostRequest(cuadroRequerimientosGetListaMetaComercialCampanaAPI(),
            payload,
            (res) => {
                setResMetaComercialCampana(res?.data ?? {});
                updateOptionsDeFiltros(res?.data?.ExtraData ?? {}, listSedes);
            }, false,
            (err) => {
                console.log("error", err);
            }, false
        );
    };

    const handleClearFilters = () => {
        setSedesFiltradosOptions([]);
        setSedesSeleccionados([]);
        setCurrentPage(1);
        setSearchCriteria("");
    };

    const refetchSedesMetaComercialCampana = async () => {
        await executeManageGetRequest(getAllSedesAPI(), async (res) => {
            const sedes = (await res?.data ?? []);
            setAllSedesOptions(sedes);
            refetchData(currentPage, sedes);
        }, false);
    };

    const refetchData = async (Page = 1, listSedes = []) => {
        const IdsSedes = sedesSeleccionados ?? [];
        await refetchMetaComercialCampana(IdsSedes, Page, listSedes);
    };

    const handleEditMetaComercialCampana = async (item) => {
        const IdMetaComercialCampana = (item?.IdMetaComercialCampana ?? 0);
        const responseSedesNotInCampana = executeManageGetRequest(getAllSedesAPI(), (res) => { }, false);
        const responsePlansCurriculares = executeManageGetRequest(cuadroRequerimientosGetDataToEditMetaComercialCampanaAPI(IdMetaComercialCampana), (res) => { }, false);
        await Promise.all([responseSedesNotInCampana, responsePlansCurriculares]).then(async (res) => {
            const dataFormated = (await res[0]?.data ?? []).map((item) => ({
                value: item.Value,
                label: item.Text
            }));
            setMetaSedeModalOptions(dataFormated);
            const data = res[1]?.data ?? {};
            data["IdMetaComercialCampana"] = IdMetaComercialCampana;
            setDataSedeModal(data);
            setTitleSedeModal("Editar Meta Comercial Por Sede");
            setModeSedeModal(true);
            setShowSedeModal(!showSedeModal);
        });
    };

    const handleDeleteMetaComercialCampana = async (item) => {
        const IdMetaComercialCampana = (item?.IdMetaComercialCampana ?? 0);
        await executeManagePostRequest(
            cuadroRequerimientosEliminarMetaComercialCampanaAPI(IdMetaComercialCampana),
            {},
            (res) => {
                refetchMetaComercialCampana([], 1);
            }, true,
            (err) => {
                console.log("error", err);
            }, true
        );
    };

    useEffect(() => {
        refetchSedesMetaComercialCampana();
    }, []);

    useEffect(() => {
        handleClearFilters();
    }, [campana]);

    useEffect(() => {
        refetchData(currentPage);
    }, [currentPage, sedesSeleccionados]);

    const handleOnChange = (res) => {
        let data = res.target?.value;
        setSearchCriteria(data);
    };

    return (
        <Styles>

            <Wrapper>
                <div>
                    <input
                        type="text"
                        className="generic-input-criterio-busqueda"
                        style={{"width":"380px"}}
                        placeholder={"Buscar por Sede"}
                        value={searchCriteria}
                        onChange={handleOnChange}
                        onKeyUp={(e) => onKeyPressEnter(e, refetchData)}
                    />

                    <button
                        type="button"
                        className="generic-button-buscador"
                        onClick={(e)=> {e.preventDefault();refetchData()}}
                    >
                        Buscar
                    </button>
                    <a className="clean-filters" onClick={handleClearFilters}>
                        Limpiar búsqueda
                    </a>

                </div>

                <div className="right-actions">
                    {(resMetaComercialCampana?.ExtraData?.PuedeCopiar ?? false) && (
                        <PrimaryActionButtonForPage onClick={handleOpenCopiarMetaModal}>
                            Copiar Meta
                        </PrimaryActionButtonForPage>
                    )}
                    {(resMetaComercialCampana?.ExtraData?.PuedeCrear ?? false) && (
                        <PrimaryActionButtonForPage onClick={handleOpenSedeModal}>
                            Adicionar Sede
                        </PrimaryActionButtonForPage>
                    )}
                </div>
        </Wrapper>

            <div className="table-container">
                <Table hover size="sm" className="custom-table">
                    <thead className='listar-thead'>
                        <tr>
                            <th className="col-sede">
                                <FormSelect
                                    options={sedesFiltradosOptions}
                                    description={'Sede'}
                                    setSelectedOptions={setSedesSeleccionados}
                                    selectedOptions={sedesSeleccionados}
                                />
                            </th>
                            <th className="col-total">
                                <div className='flex font-gothan-medium'>Total Sección</div>
                            </th>
                            <th className="col-options">
                                <div className='flex font-gothan-medium'>Acciones</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody className='listar-tbody'>
                        {(resMetaComercialCampana?.Items ?? []).map((item) => (
                            <tr key={`${uuidv4()}`}>
                                <td className="col-sede">{item.Sede}</td>
                                <td className="col-total">{item.TotalSecciones}</td>
                                <td className="col-options">
                                    {
                                        (item?.PuedeEditar ?? false) && (
                                    <FontAwesomeIcon icon={faEdit} className="action-icon" title="Editar" onClick={async () => handleEditMetaComercialCampana(item)} />
                                        )
                                    }
                                    {(item?.PuedEliminar ?? false) && (
                                        <FontAwesomeIcon icon={faTrash} className="action-icon" title="Eliminar" onClick={async () => handleDeleteMetaComercialCampana(item)} />
                                    )
                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>

            {totalPages > 1 && (
                <Paginator
                    totalItems={totalItems}
                    firsItemPage={indexOfFirstItem}
                    lastItemPage={indexOfLastItem}
                    totalPages={totalPages}
                    page={currentPage}
                    onLeftClic={prevPage}
                    onRightClic={nextPage}
                />
            )}

            {showCopiarMetaModal && (
                <div className="modal-contactanos modal-response-ficha-background">
                    <CopiarMetaModal
                        showModal={handleCloseCopiarMetaModal}
                        title="Copiar Meta"
                        campana={campana}
                        listCampanas={resCampanasDropDown}
                        refetchData={refetchData}
                    />
                </div>
            )}

            {showSedeModal && (
                <div className="modal-contactanos modal-response-ficha-background">
                    <AgregaMetaSedeModal
                        showModal={handleCloseSedeModal}
                        title={titleSedeModal}
                        mode={modeSedeModal}
                        data={dataSedeModal}
                        campana={campana}
                        listSedes={metaSedeModalOptions}
                        refetchData={refetchData}
                    />
                </div>
            )}
        </Styles>
    );
};

PlanComercialCampana.propTypes = {
    campana: PropTypes.object.isRequired,
};

export default PlanComercialCampana;


const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center; /* <-- esto lo arregla */
    gap: 10px;
    margin-bottom: 10px;

    .search-and-clean-buttons {
        display: flex;
        justify-content: center;
        align-items: center;

        button {
            margin: 0px 5px;
        }
    }

    .settingsBtn {
        width: 32px;
        height: 32px;
        background: #8a8a8a;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }

    .settingsIcon {
        width: 18px;
        height: 18px;
        fill: white;
    }
    .right-actions{
        display:flex;
        align-items:center;
        gap:8px;
    }

  
`;
